if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        if (!this.form) return;
        
        // Ensure the hidden input is enabled by default
        const variantInput = this.form.querySelector('[name=id]');
        if (variantInput) variantInput.disabled = false;
        
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        this.addEventListener('variant:change', this.onVariantChange.bind(this));
      }

      onVariantChange(event) {
        const variant = event.detail.variant;
        
        const priceSpan = this.querySelector('.product-price');
        if (priceSpan && window.Shopify && Shopify.formatMoney) {
          priceSpan.innerHTML = Shopify.formatMoney(variant.price, Shopify.money_format);
        } else if (priceSpan) {
          priceSpan.innerHTML = (variant.price / 100).toFixed(2);
        }

        const variantIdInput = this.form?.querySelector('[name=id]');
        if (variantIdInput) {
          variantIdInput.value = variant.id;
          variantIdInput.disabled = !variant.available;
        }


        // Update selling_plan input when variant changes
        const sellingPlanInput = this.form?.querySelector('[name=selling_plan]');
        if (sellingPlanInput) {
          // Get the first selling plan allocation for this variant
          const sellingPlanAllocations = variant.selling_plan_allocations || [];
          if (sellingPlanAllocations.length > 0) {
            sellingPlanInput.value = sellingPlanAllocations[0].selling_plan_id;
            sellingPlanInput.disabled = false;
          } else {
            // No selling plan for this variant - clear it
            sellingPlanInput.value = '';
            sellingPlanInput.disabled = true;
          }
        }

        if (this.submitButton) {
          this.submitButton.disabled = !variant.available;
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        
        // Re-query elements in case DOM changed
        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) {
          console.error('[ProductForm] No submit button found');
          return;
        }
        
        // Skip if already processing
        if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          return;
        }

        // Get variant ID
        const variantInput = this.form.querySelector('[name=id]');
        const variantId = variantInput?.value;
        if (!variantId) {
          console.error('[ProductForm] No variant ID found');
          return;
        }

        // Get quantity
        const quantityInput = this.form.querySelector('[name=quantity]');
        const quantity = quantityInput?.value || 1;

        // Show loading state
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        try {
          // Simple direct add to cart
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: parseInt(quantity)
            })
          });

          const data = await response.json();

          if (data.status === 422 || data.status === 'error') {
            // Error (like sold out)
            console.error('[ProductForm] Add to cart error:', data.description || data.message);
            this.handleErrorMessage(data.description || data.message);
          } else {
            // Success - dispatch cart update event
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
            
            // Open cart drawer if it exists
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            }
          }
        } catch (error) {
          console.error('[ProductForm] Network error:', error);
        } finally {
          // ALWAYS reset button state
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.removeAttribute('disabled');
          this.submitButton.disabled = false;
          
          const spinner = this.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
        }
      }

      get variantIdInput() {
        return this.form?.querySelector('[name=id]');
      }
    }
  );
}
